import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/login/_components/LoginContent.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")